var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnsembleTechniques(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F0C48A;}\r\n\t.st1{fill:#A4CFF2;}\r\n\t.st2{fill:#7BABF1;}\r\n\t.st3{fill:#4C4372;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#D3E6F8;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90,45c0,13.8-11.2,25-25,25S40,58.8,40,45s11.2-25,25-25S90,31.2,90,45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.9,41.9h34.3v20H47.9V41.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.8,41.9h3.3v20h-3.3V41.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M82.1,62.6H47.9c-0.4,0-0.7-0.3-0.7-0.7v-20c0-0.4,0.3-0.7,0.7-0.7h34.3c0.4,0,0.7,0.3,0.7,0.7v20 C82.9,62.3,82.5,62.6,82.1,62.6z M48.6,61.1h32.8V42.6H48.6V61.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M65.1,58.7H51.4V39.7h10.8c1.6,0,2.9,1.3,2.9,2.9V58.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78.8,58.7H65.1V42.6c0-1.6,1.3-2.9,2.9-2.9h10.8L78.8,58.7L78.8,58.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.1,46.7h-7.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h7.7c0.4,0,0.7,0.3,0.7,0.7 C62.8,46.4,62.5,46.7,62.1,46.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.1,43.5h-7.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h7.7c0.4,0,0.7,0.3,0.7,0.7 C62.8,43.2,62.5,43.5,62.1,43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.1,49.9h-7.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h7.7c0.4,0,0.7,0.3,0.7,0.7 C62.8,49.6,62.5,49.9,62.1,49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.1,53.1h-7.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h7.7c0.4,0,0.7,0.3,0.7,0.7 C62.8,52.8,62.5,53.1,62.1,53.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.1,56.3h-7.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h7.7c0.4,0,0.7,0.3,0.7,0.7 C62.8,56,62.5,56.3,62.1,56.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M76.3,39.7h2.5v19.1h-2.5V39.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M65.1,59.4H51.4c-0.4,0-0.7-0.3-0.7-0.7V39.7c0-0.4,0.3-0.7,0.7-0.7h10.8c2,0,3.6,1.6,3.6,3.6v16.2 C65.8,59.1,65.5,59.4,65.1,59.4z M52.1,58h12.3V42.6c0-1.2-1-2.2-2.2-2.2H52.1V58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M78.8,59.4H65.1c-0.4,0-0.7-0.3-0.7-0.7V42.6c0-2,1.6-3.6,3.6-3.6h10.8c0.4,0,0.7,0.3,0.7,0.7v19.1 C79.5,59.1,79.2,59.4,78.8,59.4z M65.8,58h12.3V40.4H68c-1.2,0-2.2,1-2.2,2.2L65.8,58L65.8,58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75.8,46.7h-7.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h7.7c0.4,0,0.7,0.3,0.7,0.7 C76.5,46.4,76.2,46.7,75.8,46.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75.8,49.9h-7.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h7.7c0.4,0,0.7,0.3,0.7,0.7 C76.5,49.6,76.2,49.9,75.8,49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75.8,53.1h-7.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h7.7c0.4,0,0.7,0.3,0.7,0.7 C76.5,52.8,76.2,53.1,75.8,53.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75.8,56.3h-7.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h7.7c0.4,0,0.7,0.3,0.7,0.7 C76.5,56,76.2,56.3,75.8,56.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75.8,43.5h-7.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h7.7c0.4,0,0.7,0.3,0.7,0.7 C76.5,43.2,76.2,43.5,75.8,43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M65.1,35.3c-4.9,0-9.4-2.6-11.8-6.8c-0.2-0.3-0.1-0.8,0.3-1c0.3-0.2,0.8-0.1,1,0.3c2.2,3.8,6.2,6.1,10.6,6.1 c4.3,0,8.4-2.3,10.6-6.1c0.2-0.3,0.6-0.5,1-0.3c0.3,0.2,0.5,0.6,0.3,1C74.4,32.7,69.9,35.3,65.1,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M65.1,37.2c-0.4,0-0.7-0.3-0.7-0.7v-1.9c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v1.9 C65.8,36.9,65.5,37.2,65.1,37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M61.4,36.7c-0.1,0-0.2,0-0.2,0c-0.4-0.1-0.6-0.5-0.5-0.9l0.6-1.8c0.1-0.4,0.5-0.6,0.9-0.5 c0.4,0.1,0.6,0.5,0.5,0.9l-0.6,1.8C62,36.6,61.7,36.7,61.4,36.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.3,35.6c-0.1,0-0.2,0-0.4-0.1c-0.3-0.2-0.5-0.6-0.3-1l0.9-1.7c0.2-0.3,0.6-0.5,1-0.3 c0.3,0.2,0.5,0.6,0.3,1l-0.9,1.7C58.8,35.4,58.5,35.6,58.3,35.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55.5,33.9c-0.2,0-0.3-0.1-0.5-0.2c-0.3-0.3-0.3-0.7-0.1-1l1.3-1.5c0.3-0.3,0.7-0.3,1-0.1 c0.3,0.3,0.3,0.7,0.1,1L56,33.6C55.9,33.8,55.7,33.9,55.5,33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M53.4,31.5c-0.2,0-0.4-0.1-0.6-0.3c-0.3-0.3-0.2-0.8,0.1-1l1.5-1.2c0.3-0.3,0.8-0.2,1,0.1 c0.3,0.3,0.2,0.8-0.1,1l-1.5,1.2C53.7,31.5,53.5,31.5,53.4,31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M68.8,36.7c-0.3,0-0.6-0.2-0.7-0.5l-0.6-1.8c-0.1-0.4,0.1-0.8,0.5-0.9s0.8,0.1,0.9,0.5l0.6,1.8 c0.1,0.4-0.1,0.8-0.5,0.9C68.9,36.7,68.8,36.7,68.8,36.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M71.8,35.6c-0.3,0-0.5-0.1-0.6-0.4l-0.9-1.7c-0.2-0.3-0.1-0.8,0.3-1c0.3-0.2,0.8-0.1,1,0.3l0.9,1.7 c0.2,0.3,0.1,0.8-0.3,1C72.1,35.5,72,35.6,71.8,35.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.6,33.9c-0.2,0-0.4-0.1-0.5-0.2l-1.3-1.5c-0.3-0.3-0.2-0.8,0.1-1c0.3-0.3,0.8-0.2,1,0.1l1.3,1.5 c0.3,0.3,0.2,0.8-0.1,1C75,33.8,74.8,33.9,74.6,33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M76.8,31.5c-0.2,0-0.3-0.1-0.5-0.2l-1.5-1.2c-0.3-0.3-0.3-0.7-0.1-1c0.3-0.3,0.7-0.3,1-0.1l1.5,1.2 c0.3,0.3,0.3,0.7,0.1,1C77.2,31.4,77,31.5,76.8,31.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnsembleTechniques);
export default __webpack_public_path__ + "static/media/EnsembleTechniques.8264e072d2b3a6418ea9ab3a34693680.svg";
export { ForwardRef as ReactComponent };